// components/Hero.js
import React from "react";

const Hero = () => {

  const scrollParaSaibaMais = () => {
    const elemento = document.getElementById("comovotar");
    if (elemento) {
      elemento.scrollIntoView({ behavior: "smooth" });
    }
  };



  return (
    <section className="relative w-full">
       <a
        href="https://cf.coop.br/eleicao-delegados-2025/boletim/comunicado-no-08-da-cge-2025-de-01-12-2025"
        target="_blank"
        rel="noopener noreferrer"
        className="block"
      >
        <img
          src="https://www.cf.coop.br/wp-content/uploads/2025/12/Banner-HOTSITE_CGE-Resultado-final.png"
          alt="edital"
          className="w-full h-auto min-h-[180px]   rounded-xl cursor-pointer"
        />
      </a>

      <div className="absolute top-[72%] left-1/2 transform -translate-x-1/2 flex justify-center gap-4 sm:gap-8 md:gap-20 lg:gap-20 whitespace-nowrap">
        {/*<button
          className="bg-amarelo border border-black text-black text-[10px] sm:text-base lg:text-lg px-4 sm:px-6 lg:px-8 py-2 rounded-md hover:bg-white transition-all duration-200"
          onClick={() => window.open('https://www.cf.coop.br/wp-content/uploads/2025/08/Edital-de-Convocacao-Eleicao-Delegados-Seccionais-2025-Edital-13.08.2025-v.12.08.2025-as-19h.pdf', '_blank')}
        >
          EDITAL
        </button>


        <button
          onClick={() => window.open('http://votacao.cf.coop.br/', '_blank')}
          className="bg-amarelo border border-black text-[8px] sm:text-base lg:text-lg px-4 sm:px-4 lg:px-8 py-1 rounded-md text-black hover:bg-white transition-all duration-200"
        >
          VOTE AQUI
        </button>      
*/}
      </div>
    </section>
  );
};

export default Hero;